// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getVendorProfileApi } from "../../Service/Api/VendorProfileApi"
import { getVendorProfileList,getErrors } from "../Reducer/VendorProfileReducer"

 

// Watchers
function* vendorProfileSaga() {
	yield takeEvery("vendorProfile_list/getVendorProfile", getVendor)
}

// Sagas
function* getVendor(action) {
	// console.log(action)
	try {
		const getVendorProfile = yield call(getVendorProfileApi, action.payload)
		// console.log(getVendorProfile.status);
		if (getVendorProfile.request.status === 200) {
			yield put(getVendorProfileList(getVendorProfile))
			// console.log(getVendorProfile.status);
		} else {
			yield put(getErrors(getVendorProfile))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(vendorProfileSaga)])
}
